<div *ngIf="error" class="alert alert-danger m-x-sm">
  <div>
    <b>{{ error.code || 'ERR' }}</b>
    <i *ngIf="error.target"> ({{ error.target }})</i>
  </div>
  <div>
    <span>{{ error.message }}</span><br>
    <ul *ngIf="error.details">
      <li *ngFor="let detail of error.details">
        {{ detail.message }}
        <span *ngIf="detail.target"> ({{ detail.target }})</span>
      </li>
    </ul>
    <span *ngIf="error.resolution">({{ error.resolution.code }}: {{ error.resolution.message }})</span>
  </div>
</div>
